import { render, staticRenderFns } from "./CreateAuthor.vue?vue&type=template&id=636a1c27&scoped=true&"
import script from "./CreateAuthor.vue?vue&type=script&lang=js&"
export * from "./CreateAuthor.vue?vue&type=script&lang=js&"
import style0 from "./CreateAuthor.vue?vue&type=style&index=0&id=636a1c27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636a1c27",
  null
  
)

export default component.exports